import { Button, Typography } from "antd";
import { FC } from "react";

import NoConnectionIcon from "@/assets/no-connection.svg?react";

import "./index.less";

type NoConnectionProps = {
  handleRecheckConnection: () => void;
};

const NoConnection: FC<NoConnectionProps> = ({ handleRecheckConnection }) => {
  return (
    <div className="no-connection-container">
      <NoConnectionIcon className="no-connection-error" />
      <Typography.Title className="no-connection-title" level={3}>
        No Internet Connection
      </Typography.Title>
      <Typography.Paragraph className="no-connection-description">
        It looks like you’re offline. Check your connection and try again to continue using the platform.
      </Typography.Paragraph>
      <Button type="primary" onClick={handleRecheckConnection}>
        Retry
      </Button>
    </div>
  );
};

export default NoConnection;
